"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { useEffect, useState } from "react"

/**
 * Returns false during SSR and the first client render, then true after mount.
 *
 * Use it to gate content that is intentionally client-only — e.g. values that
 * differ between the server and the browser (timezone-dependent dates, locale
 * formatting) and would otherwise cause a hydration mismatch (React error #418).
 * The server and the first client render agree on `false`, so no mismatch; the
 * real value is rendered after mount.
 */
export default function useHasMounted(): boolean {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    // This hook's entire purpose is the post-hydration flip; it cannot be
    // derived during render without causing the hydration mismatch it prevents.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHasMounted(true)
  }, [])

  return hasMounted
}
